import { useState } from 'react'
import { evaluateExpression } from '../api'
import { FormulInput } from './FormulaInput'

/**
 * `Değerlendir` — formül test aracı. Bot modalındaki `Çalıştır` açar.
 *
 * Yazılan ifade SUNUCUDA, botların kullanacağı motorun aynısıyla ve seçilen
 * kontratın CANLI verisiyle çalıştırılır — araç bu sayede hem formülü hem
 * motorun kendisini test ediyor. Sonuç sayı; hata mesajı motorun Türkçe
 * mesajı olduğu gibi.
 */

interface Props {
  /** Varsayılan kontrat — modalda seçili olan. */
  contract: string
  /** Seçilebilir kontratlar (aktifler). */
  contracts: string[]
  onClose: () => void
}

const SAYI = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 4 })

export function FormulaTester({ contract, contracts, onClose }: Props) {
  const [kontrat, setKontrat] = useState(contract)
  const [ifade, setIfade] = useState('')
  const [sonuc, setSonuc] = useState<{ value: number; keywords: string[] } | null>(null)
  const [hata, setHata] = useState<string | null>(null)
  const [kosuyor, setKosuyor] = useState(false)

  async function degerlendir() {
    if (!ifade.trim() || kosuyor) return
    setKosuyor(true)
    setHata(null)
    try {
      setSonuc(await evaluateExpression({ contract: kontrat, expression: ifade }))
    } catch (err) {
      setSonuc(null)
      setHata(err instanceof Error ? err.message : 'Değerlendirilemedi')
    } finally {
      setKosuyor(false)
    }
  }

  return (
    <div
      className="formula-tester"
      role="dialog"
      aria-label="Formül test aracı"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="tester-head">
        <span>Değerlendir</span>
        <button type="button" className="modal-close" onClick={onClose} aria-label="Kapat">
          ×
        </button>
      </div>

      <label className="bot-field">
        <span className="bot-field-label">Kontrat</span>
        <select
          className="bot-select"
          value={kontrat}
          onChange={(e) => {
            setKontrat(e.target.value)
            // Eski sonuç yeni kontrata aitmiş gibi durmasın.
            setSonuc(null)
            setHata(null)
          }}
        >
          {contracts.map((k) => (
            <option key={k} value={k}>
              {k}
            </option>
          ))}
        </select>
      </label>

      <label className="bot-field">
        <span className="bot-field-label">İfade</span>
        <FormulInput value={ifade} onChange={setIfade} onEnter={degerlendir} />
      </label>

      <button
        type="button"
        className="bot-btn primary tester-run"
        onClick={degerlendir}
        disabled={!ifade.trim() || kosuyor}
      >
        {kosuyor ? 'Çalışıyor…' : 'Değerlendir'}
      </button>

      {sonuc && (
        <div className="tester-result">
          <span className="tester-value">{SAYI.format(sonuc.value)}</span>
          {sonuc.keywords.length > 0 && (
            <span className="tester-keywords">Kullanılan: {sonuc.keywords.join(', ')}</span>
          )}
        </div>
      )}
      {hata && (
        <div className="tester-error" role="alert">
          {hata}
        </div>
      )}
    </div>
  )
}
